import React, { useCallback, useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingBag, X } from 'lucide-react';
const recentSales = [{
  name: 'María L.',
  city: 'Buenos Aires',
  minutes: 3
}, {
  name: 'Carlos R.',
  city: 'Córdoba',
  minutes: 7
}, {
  name: 'Susana M.',
  city: 'Rosario',
  minutes: 12
}, {
  name: 'Jorge P.',
  city: 'Mendoza',
  minutes: 18
}, {
  name: 'Graciela T.',
  city: 'La Plata',
  minutes: 22
}, {
  name: 'Roberto D.',
  city: 'Tucumán',
  minutes: 28
}, {
  name: 'Liliana F.',
  city: 'Mar del Plata',
  minutes: 35
}, {
  name: 'Héctor V.',
  city: 'Salta',
  minutes: 41
}, {
  name: 'Norma B.',
  city: 'Santa Fe',
  minutes: 48
}, {
  name: 'Eduardo G.',
  city: 'Neuquén',
  minutes: 55
}, {
  name: 'Ana C.',
  city: 'Bahía Blanca',
  minutes: 8
}, {
  name: 'Oscar K.',
  city: 'Paraná',
  minutes: 15
}];
export function SalesToast() {
  const [visible, setVisible] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const showNotification = useCallback(() => {
    setVisible(true);
    // Auto-hide after 5 seconds
    setTimeout(() => {
      setVisible(false);
    }, 5000);
  }, []);
  useEffect(() => {
    // Show first notification after 8 seconds
    const initialTimeout = setTimeout(() => {
      showNotification();
    }, 8000);
    return () => clearTimeout(initialTimeout);
  }, []);
  useEffect(() => {
    if (!visible) return;
    // When toast hides, schedule next one after 25 seconds
    const nextTimeout = setTimeout(() => {
      setCurrentIndex(prev => (prev + 1) % recentSales.length);
      showNotification();
    }, 25000);
    return () => clearTimeout(nextTimeout);
  }, [visible, showNotification]);
  const sale = recentSales[currentIndex];
  return <AnimatePresence data-id="element-320">
      {visible && <motion.div initial={{
      opacity: 0,
      y: 30,
      x: 0
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20
    }} transition={{
      duration: 0.4,
      ease: 'easeOut'
    }} className="fixed bottom-4 left-4 z-[60] max-w-xs" data-id="element-321">
          <div className="bg-white rounded-xl shadow-2xl border border-gray-100 p-4 flex items-start gap-3" data-id="element-322">
            {/* Icon */}
            <div className="flex-shrink-0 w-10 h-10 rounded-full bg-[#D8F3DC] flex items-center justify-center" data-id="element-323">
              <ShoppingBag className="w-5 h-5 text-[#1B4332]" data-id="element-324" />
            </div>

            {/* Content */}
            <div className="flex-1 min-w-0" data-id="element-325">
              <p className="text-sm font-semibold text-[#1A1A1A] leading-snug" data-id="element-326">
                {sale.name} de {sale.city}
              </p>
              <p className="text-xs text-gray-500 mt-0.5" data-id="element-327">
                compró{' '}
                <span className="font-medium text-[#1B4332]" data-id="element-328">
                  Rodilla Sin Miedo
                </span>
              </p>
              <p className="text-xs text-gray-400 mt-1" data-id="element-329">
                hace {sale.minutes} minutos
              </p>
            </div>

            {/* Close button */}
            <button onClick={() => setVisible(false)} className="flex-shrink-0 text-gray-300 hover:text-gray-500 transition-colors p-0.5" aria-label="Cerrar notificación" data-id="element-330">
              <X className="w-4 h-4" data-id="element-331" />
            </button>
          </div>

          {/* Subtle progress bar */}
          <motion.div initial={{
        scaleX: 1
      }} animate={{
        scaleX: 0
      }} transition={{
        duration: 5,
        ease: 'linear'
      }} className="h-0.5 bg-[#40916C] rounded-full mt-1 mx-2 origin-left" data-id="element-332" />
        </motion.div>}
    </AnimatePresence>;
}